(function () {
  'use strict';

  angular.module('app').component('paymentGatewaysPage', paymentGatewaysListCtrl());

  function paymentGatewaysListCtrl() {
    return {
      bindings: {},
      controller: PaymentGatewaysListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/payment-gateways/payment-gateways-page.component.html',
    };
  }

  PaymentGatewaysListCtrl.$inject = [
    'UtilService',
    'PaymentGatewayService',
    'PaymentMethodService',
  ];

  function PaymentGatewaysListCtrl(UtilService, PaymentGatewayService, PaymentMethodService) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    // public methods
    // -----------------------
    vm.onShowPaymentGateway = function (paymentGateway, mode) {
      PaymentGatewayService.openPaymentGatewayModal(paymentGateway, mode, vm.paymentMethods);
    };

    // private methods
    // -----------------------
    getPaymentGateways();
    getPaymentMethods();

    function getPaymentGateways() {
      vm.loadingPaymentGateways = true;
      PaymentGatewayService.getPaymentGateways().then(function (data) {
        vm.paymentGateways = data || [];

        vm.loadingPaymentGateways = false;
      });
    }

    function getPaymentMethods() {
      PaymentMethodService.getPaymentMethods({ get: 'active', skip_check_role: true }).then(
        function (data) {
          vm.paymentMethods = data.items;
        }
      );
    }
  }
})();
